module.exports = __webpack_public_path__ + "img/img10.260dbd9c.svg";